export default __webpack_public_path__ + "cocoa_spotlight_v2.406be709.png";